// src/pages/BranchTransferPendingList/components/exportBranchTransferPendingCsv.js
import dayjs from "dayjs";

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtDate = (val) => (val ? dayjs(val).format("DD-MM-YYYY") : "-");
const fmtNum  = (val) => Number(val || 0).toFixed(2);

/**
 * @param {object} params
 * @param {Array}   params.list     - from Redux state.branchTransferPending.list
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportBranchTransferPendingCsv = ({
  list,
  title    = "Branch Transaction Pending List",
  filename = "branch_transfer_pending",
}) => {
  const headers = [
    "No.", "Tran Req Date", "Branch Name", "Branch From Account",
    "Receive Account", "Request By", "Amount",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    fmtDate(row.tran_date),
    row.name          || "",
    row.from_acc_name || "",
    row.to_acc_name   || "",
    row.full_name     || "",
    fmtNum(row.tran_amount),
  ].map(escape));

  const grandTotal = list.reduce((s, r) => s + Number(r.tran_amount || 0), 0);

  const totalRow = [
    "Grand Total:", "", "", "", "", "",
    fmtNum(grandTotal),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};